module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "mk.519215c1.png" + "?" + Date.now();